import * as React from "react";
import {
  Button,
  Grid,
  Modal,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TextField,
  Typography,
  Paper as MuiPaper,
  MenuItem,
  Select,
  CircularProgress,
  Checkbox,
  Tabs,
  Tab,
  FormControl,
  InputLabel,
  FormControlLabel,
  Switch,
  OutlinedInput,
  InputAdornment,
} from "@mui/material";
import useAuth from "../../../hooks/useAuth";
import Link from "@mui/material/Link";
import { NavLink, useNavigate } from "react-router-dom";
import { Box, spacing } from "@mui/system";
import styled from "@emotion/styled";
import { useState } from "react";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import dayjs, { Dayjs } from "dayjs";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { ptBR } from "date-fns/locale";
import { useEffect } from "react";
import PropTypes from "prop-types";

export default function CreateDiscountPaymentComponent({createCompoment}) {
  let { getApi, postApi, user, signUpStep2, isBSAccount, isInitializedBS } =
    useAuth();
  const [tabVal, setTabVal] = React.useState(0);

 let { 
    applyDiscount,
setApplyDiscount,
setDiscountModality,
discount_modality,
setValorDesconto,
discount_value,
setDiscountGoalDate,
discount_goal_date
  } = createCompoment;
  

  return (
    <React.Fragment>
     <Grid container spacing={6}>
                  <Grid item md={4}>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={applyDiscount}
                          onChange={(e) => setApplyDiscount(!applyDiscount)}
                          name="gilad"
                        />
                      }
                      label="Aplicar desconto antes de vencer"
                    />
                  </Grid>
                </Grid>
                {applyDiscount && (
                  <Grid container spacing={6} mt={1}>
                    <Grid item md={4}>
                      <FormControl sx={{ m: 1, width: "25ch" }}>
                        <InputLabel id="demo-simple-select-label">
                          Tipo de Desconto
                        </InputLabel>
                        <Select
                          fullWidth
                          required
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          label="Tipo de Desconto"
                          onChange={(e) => setDiscountModality(e.target.value)}
                          value={discount_modality}
                        >
                          <MenuItem value={"percent"}>Porcentagem</MenuItem>
                          <MenuItem value={"fixedvalue"}>Valor Fixo</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item md={4}>
                      <FormControl
                        sx={{ m: 1, width: "25ch" }}
                        variant="outlined"
                      >
                        <InputLabel htmlFor="outlined-adornment-amount">
                          {discount_modality == "percent" ? "%" : "Reais"} de
                          desconto
                        </InputLabel>
                        <OutlinedInput
                          id="outlined-adornment-weight"
                          endAdornment={
                            <InputAdornment position="end">
                              {discount_modality == "percent" ? "%" : "reais"}
                            </InputAdornment>
                          }
                          label="Juros ao mês"
                          type={"number"}
                          step={0.01}
                          max={20}
                          onChange={(e) => setValorDesconto(e.target.value)}
                          value={
                            discount_modality == "fixedvalue"
                              ? parseFloat(discount_value)
                                  .toFixed(2)
                                  .toLocaleString("pt-br", {
                                    style: "currency",
                                    currency: "BRL",
                                  })
                              : parseFloat(discount_value).toFixed(2)
                          }
                        />
                      </FormControl>
                    </Grid>
                    <Grid item md={3}>
                      <FormControl
                        sx={{ m: 1, width: "25ch" }}
                        variant="outlined"
                      >
                        <InputLabel htmlFor="outlined-adornment-amount">
                          Dias antes de vencer
                        </InputLabel>
                        <Select
                          required
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          label="Status da assinatura"
                          value={discount_goal_date}
                          onChange={(e) => setDiscountGoalDate(e.target.value)}
                          sx={{
                            textAlignLast: "center",
                          }}
                        >
                          <MenuItem value={0}>Até o vencimento</MenuItem>
                          <MenuItem value={1}>1 dia antes</MenuItem>
                          {[...Array(60)].map(
                            (e, i) =>
                              i > 1 && (
                                <MenuItem key={i} value={i}>
                                  {i} dias antes
                                </MenuItem>
                              )
                          )}
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>
                )}
    </React.Fragment>
  );
}

